export const primary = {
    "primary100": "#00006B",
    "primary200": "#000045",
    "primary300": "#FD5000"
}

export const secondary = {
    "secondary100": "#00ACEF",
    "secondary200": "#CE0019"
}

export const grayScale = {
    "gray100": "#F3F5F8",
    "gray200": "#C2C9DA",
    "gray300": "#919CB6",
    "gray400": "#26355C"
} 

export const warnings = {
    "error": "#FF0101",
    "success": "#05EC99",
    "warning": "#FFA800"
}

export const white = '#ffffff'
